module.exports = __webpack_public_path__ + "img/statistics-chart-default.78e0826b.svg";